<mat-form-field style="padding-top: 1rem;">
  <mat-label>Suche</mat-label>
  <input matInput (keyup)="applyFilter($event)" #input>
</mat-form-field>

@if (isLoading()) {
  <mat-progress-bar mode="indeterminate" />
}

<table mat-table [dataSource]="allChecks" matSort (matSortChange)="clearPin()">

    <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FB / LP / Titel </th>
        <td mat-cell *matCellDef="let p"> {{p.displayName}} </td>
    </ng-container>
    <ng-container matColumnDef="creator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ersteller & <br> Kontrolle 1-1 </th>
        <td mat-cell *matCellDef="let p">
            {{p.creator?.displayName || '-'}}
            @if(p.creator && p.status >= 1){<mat-icon style="color: var(--IL-secondary-Green);">check_circle</mat-icon>}
            @else if(p.creator){<mat-icon style="color: var(--IL-secondary-Red);">cancel</mat-icon>}
        </td>
    </ng-container>
    <ng-container matColumnDef="checker12">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>  <br> Kontrolle 1-2 </th>
        <td mat-cell *matCellDef="let p">
            @if (p.isConsultant) {
                <span class="skipped-phase" matTooltip="Gutachterliche Tätigkeit – Kontrolle 1-2 übersprungen">
                    <mat-icon style="color: var(--mat-sys-on-surface-variant); font-size: 1.1rem; vertical-align: middle;">block</mat-icon>
                    Übersprungen
                </span>
            } @else {
                {{p.checker12?.displayName || '-'}}
                @if(p.checker12 && p.status >= 2){<mat-icon style="color: var(--IL-secondary-Green);">check_circle</mat-icon>}
                @else if(p.checker12 && p.status >= 1){<mat-icon style="color: var(--IL-secondary-Red);">cancel</mat-icon>}
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="dueDate1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prüffrist <br> Kontrolle 1</th>
        <td mat-cell *matCellDef="let p"> {{formatDate(p.dueDate1)}} </td>
    </ng-container>
    <ng-container matColumnDef="checker2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> <br> Kontrolle 2</th>
        <td mat-cell *matCellDef="let p">
            {{p.checker2?.displayName || '-'}}
            @if(p.checker2 && p.status >= 3){<mat-icon style="color: var(--IL-secondary-Green);">check_circle</mat-icon>}
            @else if(p.checker2 && p.status >= 2){<mat-icon style="color: var(--IL-secondary-Red);">cancel</mat-icon>}
        </td>
    </ng-container>
    <ng-container matColumnDef="dueDate2">
        <th mat-header-cell *matHeaderCellDef>Prüffrist <br> Kontrolle 2</th>
        <td mat-cell *matCellDef="let p"> {{formatDate(p.dueDate2)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [routerLink]="row.project?.contractNr ? ['/qs/project', row.project.contractNr, 'check', row.id] : null"
        [class.clickable-row]="!!row.project?.contractNr"
    ></tr>
    <tr class="mat-row" *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length" style="padding: 1rem; text-align: center; color: var(--mat-sys-on-surface-variant);">
            @if (isLoading()) { Kontrollen werden geladen… }
            @else { Keine Kontrollen vorhanden. }
        </td>
    </tr>
</table>
